// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"267":"af5e23fe3f68e456","2869":"e5eb20be5ca15ebb","6327":"b830957336ff2842","7963":"13a876572bbe6dca"}[chunkId] + ".css";
};